<div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">
      <!-- Forgot Password v1 -->
      <div class="card mb-0">
        <div class="card-body">
          <a href="javascript:void(0);" class="brand-logo">
            <img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" height="200" />
          </a>
          <div style="text-align: center;">
            <h2 class="brand-text text-primary ml-1">COCOLAB</h2>
          </div>
          
         

          <h4 class="card-title mb-1">¿Has olvidado tu contraseña? 🔒</h4>
          <p class="card-text mb-2">Ingrese su correo electrónico y le enviaremos instrucciones para restablecer su contraseña</p>
  
          <form class="auth-forgot-password-form mt-2" [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()">
            <div class="form-group">
              <label for="forgot-password-email" class="form-label">Correo electrónico</label>
              <input
                type="text"
                class="form-control"
                placeholder=""
                formControlName="email"
                aria-describedby="forgot-password-email"
                tabindex="1"
                autofocus
                [ngClass]="{ 'is-invalid': submitted && f.email.errors }"
              />
              <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                <div *ngIf="f.email.errors.required">correo electrónico es requerido</div>
                <div *ngIf="f.email.errors.email">El correo electrónico debe ser una dirección válida</div>
              </div>
            </div>
            <button class="btn btn-primary btn-block" tabindex="2" rippleEffect>Enviar</button>
          </form>
  
          <p class="text-center mt-2">
            <a routerLink="">
              <i data-feather="chevron-left" class="mb-25"></i> Volver a Inicio sesión
            </a>
          </p>
        </div>
      </div>
      <!-- /Forgot Password v1 -->
    </div>
  </div>
  